import React from "react"

const FreeDiscoveryCallBlock = ({ practice, theme }) => {
  // Find the first free service
  const freeService = practice.services.find((service) => service.amountCents === 0)

  if (!freeService) {
    return null
  }

  const handleBookFree = () => {
    const proSlug = practice.user.vanitySlug || practice.user.vanity_slug || practice.user.slug
    const segment = freeService.publicSlug || freeService.public_slug || freeService.id
    window.location.href = `/${proSlug}/services/${segment}`
  }

  // Support both v1 and v2 theme structures
  // Use primary color for accent elements
  const textDarkColor = theme?.colors?.textDark || theme?.colorTextDark
  const greyLightestColor = theme?.colors?.greyLightest || theme?.colorGreyLightest
  const accentColor = theme?.colors?.primary || theme?.colorPrimary || theme?.colors?.accent || theme?.colorAccent
  const bgLightColor = theme?.colors?.bgLight || theme?.colorBgLight
  const headingFont = theme?.fonts?.heading || theme?.fontHeading
  const headingWeight = theme?.fonts?.headingWeight || theme?.fontHeadingWeight

  return (
    <div className="mb-8 rounded-lg p-6" style={{ backgroundColor: greyLightestColor }}>
      <div className="flex flex-row items-center justify-between gap-4 sm:flex-col sm:items-start">
        <div className="flex-1">
          <h3
            className="mb-2 text-2xl font-bold leading-tight"
            style={{
              color: textDarkColor,
              fontFamily: headingFont,
              fontWeight: headingWeight
            }}>
            Book a free discovery call
          </h3>
          <p className="text-base leading-normal" style={{ color: textDarkColor }}>
            Learn more about this practitioner and event.
          </p>
        </div>

        <button
          onClick={handleBookFree}
          className="whitespace-nowrap rounded px-6 py-3 font-semibold leading-normal transition-colors hover:opacity-90"
          style={{
            backgroundColor: accentColor,
            color: bgLightColor
          }}>
          Book for free
        </button>
      </div>
    </div>
  )
}

export default FreeDiscoveryCallBlock
